export const izoneHero = {
  breadcrumb: "iZone Smart Control",
  eyebrow: "iZONE SMART CLIMATE CONTROL · PERTH WA",
  title: "iZone smart air conditioning,",
  highlight: "room by room.",
  intro: "iZone turns a compatible ducted system into a smart, room-by-room climate system you control from your phone, a wall touchscreen or your voice. Developed in Western Australia and part of Rinnai Australia since 2023, it is the natural upgrade for Perth homes that want more control and less waste.",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/fc76cc97-6afa-46bf-b30a-ee90d52d4780.jpg",
  imageAlt: "Wall touchscreen and smartphone showing room-by-room climate control",
  facts: ["Up to 14 zones", "Phone, touchscreen and voice", "Part of Rinnai since 2023"],
};

export const izoneQuickAnswer = {
  question: "What does iZone do?",
  answer: "iZone is a smart control system for ducted air conditioning. Wireless sensors and touchscreen controllers measure the temperature room by room and adjust airflow automatically, so each zone holds its own setting. Because conditioned air only goes where it is needed, iZone helps lower running costs, and it can expand into lighting, irrigation and other smart-home functions.",
  points: [
    { label: "Zones", value: "Up to 14" },
    { label: "Controllers", value: "Nova, Nexus Plus, Nexus or app only" },
    { label: "Sensing", value: "Wireless, roaming and occupancy" },
    { label: "Voice", value: "Google Home, Alexa and Siri*" },
    { label: "Ownership", value: "Rinnai Australia since 2023" },
    { label: "Warranty", value: "5 years on selected products*" },
  ],
};

export const izoneFeatures = [
  {
    title: "Degree-perfect room control",
    text: "A temperature sensor in every touchscreen, plus roaming sensors, keeps each zone at its exact set temperature. All sensors can be calibrated for precision.",
  },
  {
    title: "Efficiency built in",
    text: "Fan auto control and an in-duct supply air sensor match airflow to demand, so the system never works harder than it needs to.",
  },
  {
    title: "Occupancy sensing",
    text: "The iSense occupancy sensor, with a backlit display and full in-room control, helps avoid heating and cooling empty rooms.",
  },
  {
    title: "Air quality monitoring",
    text: "Track humidity, CO2 and volatile organic compounds, and check outdoor air quality, on supported controllers.",
  },
  {
    title: "App and voice control",
    text: "Control from anywhere with the iZone app, or by voice with Google Home, Amazon Alexa and Siri on compatible systems.",
  },
  {
    title: "Part of the Rinnai family",
    text: "Acquired by Rinnai Australia in 2023, with select iZone products supported by Rinnai’s national 1stCare service network.",
  },
];

export const izoneSmartHome = {
  eyebrow: "SCALABLE SMART HOME",
  title: "Start with comfort. Add smart home when you’re ready.",
  text: "Your iZone climate system becomes the foundation for a wider smart home. Add as much or as little as you like, now or later, and control everything from the same app.",
  points: [
    "Smart LED lighting and dimming",
    "Irrigation with up to 24 stations",
    "Smart plugs for everyday appliances",
    "Power monitoring",
    "Security and garage doors",
    "Roller blinds and automations",
  ],
  image: "https://cdn.magicpatterns.com/patterns/generated-images/6d0072cf-1c17-4313-a0df-38bc8cdcd47e.jpg",
  imageAlt: "Modern Perth home at dusk with warm interior lighting",
  note: "Smart-home products are optional extras and are quoted separately.",
};

export const izoneComparison = {
  columns: ["", "Rinnai Home Controller", "iZone"],
  rows: [
    ["Zones", "Up to 8", "Up to 14"],
    ["Wall controller", "8-inch touchscreen", "6, 8 or 10-inch touchscreens, or app only"],
    ["Room sensing", "Wireless room sensors", "Wireless and roaming sensors, plus occupancy sensing"],
    ["Air quality monitoring", "Not included", "Humidity, CO2 and VOCs on supported controllers"],
    ["Voice control", "Google Home, Alexa and Siri*", "Google Home, Alexa and Siri*"],
    ["Smart-home expansion", "Climate control only", "Lighting, irrigation, power, security and more"],
    ["Best for", "Straightforward zoned comfort", "More zones and a smarter home"],
  ],
};

export const izoneSteps = [
  {
    title: "Tell us about your home",
    text: "Share your current or planned ducted system, the number of rooms and what you want to control.",
  },
  {
    title: "Compatibility check",
    text: "We confirm your indoor unit, ductwork, zone dampers and Wi-Fi setup suit iZone.",
  },
  {
    title: "Zone and sensor design",
    text: "We plan zones, sensor locations and the right controller for how your household lives.",
  },
  {
    title: "Install and set up",
    text: "We install and commission the system, then set up the iZone app and voice assistants with you.",
  },
];
